module.exports = __webpack_public_path__ + "static/media/work.b51792e7.jpeg";